export interface FormattedChannelStatus {
  key: 'email' | 'sms' | 'push' | 'unknown';
  icon: string;
  label: string;
  source: string;
  status: 'delivered' | 'pending' | 'failed' | 'unavailable';
  statusLabel: string;
}

export function formatChannelStatus(channelStatus: any): FormattedChannelStatus {
  const rawChannel = String(channelStatus.channelType || channelStatus.type || '').toUpperCase();
  const rawStatus = String(channelStatus.deliveryStatus || channelStatus.status || 'SCHEDULED').toUpperCase();
  const retryPublicStatus = String(channelStatus.retryPublicStatus || '').toUpperCase();

  let key: FormattedChannelStatus['key'] = 'unknown';
  let icon = '•';
  let label = 'Channel';
  let source = '';

  if (channelStatus.isNotificationFallback) {
    label = 'Delivery';
    icon = '⚠';
  }

  if (rawChannel.indexOf('EMAIL') !== -1) {
    key = 'email';
    icon = '✉';
    label = 'Email';
    source = rawChannel.indexOf('MIS') !== -1 ? 'MIS' : '';
  } else if (rawChannel.indexOf('SMS') !== -1) {
    key = 'sms';
    icon = '●';
    label = 'SMS';
    source = rawChannel.indexOf('MIS') !== -1 ? 'MIS' : '';
  } else if (
    rawChannel.indexOf('IOS') !== -1 ||
    rawChannel.indexOf('ANDROID') !== -1 ||
    rawChannel.indexOf('PUSH') !== -1
  ) {
    key = 'push';
    icon = '♢';
    label = 'Push';
    source = rawChannel.indexOf('ANDROID') !== -1 ? 'Android' : rawChannel.indexOf('IOS') !== -1 ? 'iOS' : '';
  }

  // Provider/internal failures intentionally use neutral school-facing copy.
  // Details such as account balance, credentials or provider names remain in
  // backend diagnostics and are never rendered in the school interface.
  if (retryPublicStatus === 'RETRY_SCHEDULED') {
    return { key, icon, label, source, status: 'pending', statusLabel: 'Retry scheduled' };
  }
  if (retryPublicStatus === 'DELIVERY_IN_PROGRESS') {
    return { key, icon, label, source, status: 'pending', statusLabel: 'Delivery in progress' };
  }
  if (retryPublicStatus === 'SERVICE_UNAVAILABLE') {
    return { key, icon, label, source, status: 'unavailable', statusLabel: 'Temporarily unavailable' };
  }
  if (retryPublicStatus === 'CHECK_RECIPIENT') {
    return { key, icon, label, source, status: 'unavailable', statusLabel: 'Check contact details' };
  }
  if (retryPublicStatus === 'RETRIES_EXHAUSTED') {
    return { key, icon, label, source, status: 'failed', statusLabel: 'Failed after retries' };
  }
  if (retryPublicStatus === 'DELIVERY_FAILED') {
    return { key, icon, label, source, status: 'failed', statusLabel: 'Delivery could not be completed' };
  }

  if (['DELIVERED', 'READ'].indexOf(rawStatus) !== -1) {
    return { key, icon, label, source, status: 'delivered', statusLabel: 'Delivered' };
  }
  if (rawStatus === 'SENT') {
    return { key, icon, label, source, status: 'delivered', statusLabel: 'Sent' };
  }
  if (rawStatus === 'ERROR') {
    return { key, icon, label, source, status: 'failed', statusLabel: 'Failed' };
  }
  if (['NO_CHANNELS', 'NOT_SENT', 'UNSUPPORTED_CHANNEL_TYPE'].indexOf(rawStatus) !== -1) {
    return { key, icon, label, source, status: 'unavailable', statusLabel: 'Unavailable' };
  }
  return { key, icon, label, source, status: 'pending', statusLabel: 'Pending' };
}
